module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Black.ac7dda4b.ttf";